import { cn } from "../../utils";
import { Skeleton } from "../Skeleton";
import { useTableContext } from "./context";
import { TableCell } from "./TableCell";

type Props = {
  className?: string;
};

export function TableLoadingRow({ className }: Props) {
  const { columns, rowDensity, selection, gridTemplateColumns } =
    useTableContext();

  const heightClass = {
    dense: "h-[42px]",
    default: "h-[52px]",
    expanded: "h-[60px]",
  }[rowDensity.value];

  return (
    <div
      className={cn(
        "grid min-w-fit border-b border-neutral-500/5",
        heightClass,
        className,
      )}
      style={{ gridTemplateColumns }}
      role="row"
    >
      {selection && (
        <div className="flex items-center justify-center min-w-0">
          <div className="w-4 h-4">
            <Skeleton className="w-full h-full rounded-sm" />
          </div>
        </div>
      )}
      {columns.map((column) => {
        return (
          <TableCell key={column.key} align={column.align}>
            <Skeleton className="w-full h-[18px]" />
          </TableCell>
        );
      })}
    </div>
  );
}
